export default "__VITE_ASSET__BKeDSkiv__"